<div class="row m-1 max-vw-100 justify-content-center">
  <div class="row">
    <div class="table-responsive">
      <table class="table table-bordered align-middle">
        <thead>
          <tr>
            <th scope="col" class="h6 fw-bolder" width="2%">Id</th>
            <th scope="col" class="h6 fw-bolder" width="7%">
              Form Field Label
            </th>
            <th scope="col" class="h6 fw-bolder" width="53%">
              Form Field Name
            </th>
            <th scope="col" class="h6 fw-bolder" width="38%">Attribute Name</th>
          </tr>
        </thead>
        <tbody>
          @for (
            qn of questionsList
              | paginate
                : {
                    itemsPerPage: numberOfItemsPerPage,
                    currentPage: currentPageNumber,
                    totalItems: totalNumberOfItems,
                  };
            track qn
          ) {
            <tr
              class=""
              [ngClass]="
                qn.IsMappable &&
                qn.Attributes.length !== 0 &&
                (qn.Attributes[0].AttributeName === null ||
                  qn.Attributes[0].AttributeName === undefined ||
                  qn.Attributes[0].AttributeName === '')
                  ? 'table-warning--'
                  : fieldsWithDuplicateAttributeNames.length > 0 &&
                      fieldsWithDuplicateAttributeNames.includes(qn)
                    ? 'table-danger--'
                    : ''
              "
            >
              <td scope="row">{{ qn.DisplayOrder }}</td>
              <!-- Actually Form field label is getting mapped into qn.Name -->
              <td>{{ qn.Name }}</td>
              <!-- and Form field name is getting mapped into qn.Label -->
              <td>{{ qn.Label?.slice(0, 100) }}...</td>
              <td>
                @if (qn.IsMappable) {
                  <div
                    class="d-flex align-items-center justify-content-start gap-1"
                  >
                    <input
                      type="text"
                      class="form-control"
                      [name]="qn.Attributes[0]?.AttributeValue"
                      [id]="qn.Attributes[0].ID"
                      aria-describedby="helpId"
                      placeholder="Please provide an attribute"
                      [(ngModel)]="qn.Attributes[0].AttributeName"
                      (keypress)="saveAttrMaps()"
                      (keydown)="saveAttrMaps()"
                      (keyup)="saveAttrMaps()"
                    />
                    <button
                      type="button"
                      class="btn btn-danger"
                      (click)="
                        qn.Attributes[0].AttributeName = ''; saveAttrMaps()
                      "
                      [disabled]="
                        qn.Attributes[0].AttributeName === null ||
                        qn.Attributes[0].AttributeName === ''
                      "
                    >
                      <i class="fa fa-solid fa-trash text-light"></i>&nbsp;Clear
                    </button>
                  </div>
                  @if (
                    fieldsWithDuplicateAttributeNames.length > 0 &&
                    fieldsWithDuplicateAttributeNames.includes(qn)
                  ) {
                    <small id="helpId" class="form-text text-danger">
                      Duplicate attribute:
                      @for (
                        duplicateField of fieldsWithDuplicateAttributeNames;
                        track duplicateField;
                        let idx = $index;
                        let isLast = $last
                      ) {
                        <span>
                          @if (!isLast) {
                            <span
                              >Question-{{
                                duplicateField["DisplayOrder"]
                              }},&nbsp;</span
                            >
                          }
                          @if (isLast) {
                            <span
                              >and Question-{{
                                duplicateField["DisplayOrder"]
                              }}</span
                            >
                          }
                        </span>
                      }
                    </small>
                  }
                } @else {
                  <p class="">Data mapping is disabled for this form field</p>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
      <div
        class="d-flex justify-content-end align-items-center bg-body-tertiary pt-3"
      >
        <pagination-controls
          (pageChange)="onPageChange($event)"
        ></pagination-controls>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="d-flex justify-content-end align-items-center my-2">
      <button
        type="button"
        class="d-none btn btn-success me-1"
        (click)="toggleJsonStructure = !toggleJsonStructure"
      >
        Toggle JSON
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="saveAttrMaps('database')"
        [disabled]="fieldsWithDuplicateAttributeNames.length > 0"
      >
        <i class="fa fa-solid fa-save"></i>&nbsp;Save
      </button>
    </div>
  </div>
</div>

@if (toggleJsonStructure) {
  <code class="row m-1 max-vw-100 justify-content-center">
    <pre class="border border-primary p-1 my-1 d-none">{{
      allQuestionsFromLocalStore | json
    }}</pre>
    <pre class="border border-danger p-1 my-1">{{
      attributeMappingsPayload | json
    }}</pre>
  </code>
}
